export const buyers = [
  { name: 'María González', country: 'Mexico' },
  { name: 'Carlos Ramírez', country: 'Colombia' },
  { name: 'Lucía Fernández', country: 'Argentina' },
  { name: 'Javier Morales', country: 'Chile' },
  { name: 'Valentina Torres', country: 'Peru' },
  { name: 'Andrés Castillo', country: 'Spain' },
  { name: 'Camila Herrera', country: 'Ecuador' },
  { name: 'Diego Salazar', country: 'Venezuela' },
  { name: 'Gabriela Méndez', country: 'Guatemala' },
  { name: 'Martín Pereira', country: 'Uruguay' },
  { name: 'Daniela Rojas', country: 'Costa Rica' },
  { name: 'Sebastián Vargas', country: 'Bolivia' },
  { name: 'Paula Jiménez', country: 'Dominican Republic' },
  { name: 'Ricardo Benítez', country: 'Paraguay' },
  { name: 'Isabel Quintero', country: 'Panama' },
  { name: 'Fernando Aguilar', country: 'Honduras' },
  { name: 'Natalia Cruz', country: 'El Salvador' },
  { name: 'Alejandra Ortiz', country: 'Puerto Rico' },
];
